export default __webpack_public_path__ + "static/media/search-icon.1dc2d9a5.svg";